import { useT } from "@/context/LangContext";
import TeamSection from "@/components/TeamSection";

export default function About() {
  const t = useT();
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20" data-testid="about-page">
      <p className="kicker">{t("about.kicker")}</p>
      <h1 className="text-5xl lg:text-7xl font-display font-black tracking-tighter mt-4">
        {t("about.title1")} <br />
        <span className="text-[var(--accent)]">{t("about.title2")}</span> <br />
        {t("about.title3")}
      </h1>
      <div className="prose max-w-none mt-10 text-lg leading-relaxed text-[var(--ink-soft)]">
        <p>{t("about.p1")}</p>
        <p>{t("about.p2")}</p>
        <p>{t("about.p3")}</p>
        <h2 className="font-display text-3xl font-bold mt-12 text-[var(--ink)]">{t("about.commitments")}</h2>
        <ul>
          <li><strong>{t("about.c1.b")}</strong> {t("about.c1.t")}</li>
          <li><strong>{t("about.c2.b")}</strong> {t("about.c2.t")}</li>
          <li><strong>{t("about.c3.b")}</strong> {t("about.c3.t")}</li>
        </ul>
      </div>

      <TeamSection />
    </div>
  );
}
